import { EventHub } from '@/constants/constants'
import { DialogHarvest } from '@/tools/dialog'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    name: 'EnterpriseHarvestTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
    }),
    computed: {
    },
    created () {
        this.$eventBus.$on(EventHub.COMMIT_HARVEST, (harvestDto) => {
            this.model.harvestStartTime.harvests = this.model?.harvestStartTime?.harvests?.concat([harvestDto]);
        })
        this.$eventBus.$on(EventHub.UPDATE_HARVEST, (harvestDto) => {
            const harvestIndex = this.model?.harvestStartTime?.harvests?.findIndex(harvest => harvest.name === harvestDto.name)
            delete harvestDto.oldDate
            if (harvestIndex > -1) {
                const newHarvests = JSON.parse(JSON.stringify(this.model?.harvestStartTime?.harvests))
                this.model.harvestStartTime.harvests = []
                newHarvests.splice(harvestIndex, 1, harvestDto)
                this.model.harvestStartTime.harvests = newHarvests
            }
        })
    },
    beforeDestroy () {
        this.$eventBus.$off(EventHub.COMMIT_HARVEST)
        this.$eventBus.$off(EventHub.UPDATE_HARVEST)
    },
    mounted () {
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Carga el dialog para crear una zafra
         */
        createHarvest() {
            const bread = {
                key: DialogHarvest,
                disabled: true,
                text: this.$t('harvest.name'),
                model: {
                    harvests: this.model?.harvestStartTime?.harvests,
                    state: 'inactive',
                    update: false,
                }
            }
            this.$eventBus.$emit('initFields', bread.model)
            this.pushBread(bread)
        },
        editHarvest(item) {
            const harvest = JSON.parse(JSON.stringify(item))
            const objDate = new Date(harvest.date * 1000)
            const timezone = this.model.enterpriseTimezone
            const date = moment(objDate).utcOffset(timezone).format('yyyy-MM-DDTHH:mm')
            const bread = {
                key: DialogHarvest,
                disabled: true,
                text: this.$t('harvest.name'),
                model: {
                    harvests: this.model?.harvestStartTime?.harvests,
                    name: harvest.name,
                    date,
                    oldDate: date,
                    state: harvest.state,
                    update: true,
                    tonsPerHour: harvest.tonsPerHour,
                    speedPorcentageValue: harvest.speedPorcentageValue
                }
            }
            this.$eventBus.$emit('initFields', bread.model)
            this.pushBread(bread)

        },

        formatDate(date) {
            const format = 'DD/MM/YYYY HH:mm';
            const timezone = this.model.enterpriseTimezone
            const objDate = new Date(date * 1000)
            return moment(objDate, format).utcOffset(timezone).format(format);
        },
        async removeHarvest(index) {
            this.model?.harvestStartTime?.harvests?.splice(index, 1)
        }
    },
    watch: {
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseHarvestsForm) {
                this.$refs.enterpriseHarvestsForm.resetValidation()
            }
        }
    }
}
